import gql from 'graphql-tag'

export const getProductQuery = gql`
  query GetProductByID($id: Int!) {
    product(id: $id, onlyActive: false) {
      weight
      mpn
      evo
      hideFitStyles: hide_fit_styles
      sizeTag: size_tag
      youthCombined: youth_combined
      shortDescription: short_description
      colorGenders: color_genders
      hasInventory: has_inventory
      inventoryJson: inventory_json
      fitStyles {
        id
        info
        name: description
      }
      sizeRange: size_range {
        id
        name
        isYouth: is_youth
      }
      upgradeOne: upgrade_one {
        id
        shortId: short_id
        enabled
        name
        url
        defaultOption: default_option
        modalImage: modal_image
        mobileImage: mobile_image
        options {
          aud
          id
          cad
          shortId: short_id
          gbp
          name
          usd
          eur
        }
      }
      upgradeTwo: upgrade_two {
        id
        shortId: short_id
        enabled
        name
        url
        defaultOption: default_option
        modalImage: modal_image
        mobileImage: mobile_image
        options {
          aud
          id
          cad
          shortId: short_id
          gbp
          name
          usd
          eur
        }
      }
      upgradeThree: upgrade_three {
        id
        shortId: short_id
        enabled
        name
        url
        defaultOption: default_option
        modalImage: modal_image
        mobileImage: mobile_image
        options {
          aud
          id
          cad
          shortId: short_id
          gbp
          name
          usd
          eur
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/ProductThumbnail/data.ts